export default "__VITE_ASSET__DyHS1o1r__"